<template>
  <div class="assigned-shift" @click="selectClaim">
    <div :class="['radio-box', isSelected ? 'selected' : '']">
      <CheckCircleFilled
        :color="isSelected ? PaletteColors['brand-primary'] : PaletteColors['base-white']"
      ></CheckCircleFilled>
    </div>
    <EmployeeCardSmall
      v-if="props.employee"
      :claim="
        formatClaimForProfile({
          roles: props.employee.roles, // employee roles
          function: props.employee.function, // shift function
          role: props.employee.role, // shift role
          raise_shifts_worked: props.employee.raise_shifts_worked,
          raise_rating_avg: props.employee.raise_rating_avg,
          internal_rating_for_worker: props.employee.internal_rating_for_worker,
          worker_id: props.employee.worker_id,
          worker_name: props.employee.worker_name,
          distance_km: props.employee.distance_km,
        })
      "
    ></EmployeeCardSmall>
    <ChildShiftCard :shift="props.shift"></ChildShiftCard>
  </div>
</template>

<script setup>
import CheckCircleFilled from '@/assets/icons/CheckCircleFilled.vue';
import ChildShiftCard from '@/pages/talent-pool/jobs/components/ChildShiftCard.vue';
import EmployeeCardSmall from '@/pages/talent-pool/components/EmployeeCardSmall.vue';
import { PaletteColors } from '@/Theme';
import { computed } from 'vue';
import { formatClaimForProfile } from '@/pages/talent-pool/utils/profile';

const props = defineProps({
  shift: Object,
  selected: Boolean,
  employee: Object,
});

const isSelected = computed(() => props.selected);

const emit = defineEmits(['onSelect']);

const selectClaim = () => {
  emit('onSelect');
};
</script>

<style scoped>
.assigned-shift {
  display: flex;
  background: var(--palette-color-base-white);
  padding: 1rem;
  gap: 0.5rem;
  border-radius: 8px;
  align-items: center;
}

.radio-box {
  border-radius: 50%;
  width: 26px;
  height: 26px;
  border: 1px solid var(--palette-color-default-lighten-60);
  display: flex;
  justify-content: center;
  align-items: center;
}

.radio-box.selected {
  border: 1px solid var(--palette-color-brand-primary);
}
</style>
